export const parseArticleElements = (elementArray) => {
  if (elementArray.length > 0) {
    return elementArray
      .filter((e) => e?.__typename === 'Text')
      .map((e) => e.children)
      .join(' ')
      .replace(/<p>/g, '')
      .replace(/<\/p>/g, '');
  }
  return null;
};
